/*
 * @Author: zhenglfsir@gmail.com
 * @Date: 2018-12-27 14:56:16
 * @Last Modified by: zhenglfsir@gmail.com
 * @Last Modified time: 2019-05-17 15:19:56
 * redux 中间件
 */
import * as Sentry from '@sentry/browser';

export const createPromiseMiddleware = (effects) => {
  return (store) => (next) => (action) => {
    if (effects[action.type]) {
      return new Promise((resolve, reject) => {
        next({ _resolve: resolve, _reject: reject, ...action });
      });
    }
    return next(action);
  };
};

export const createCrashReporterMiddleware = () => {
  return (store) => (next) => (action) => {
    try {
      return next(action);
    } catch (err) {
      Sentry.withScope((scope) => {
        scope.addBreadcrumb({
          type: 'High-Error',
          category: 'redux',
          message: action.type,
        });
        scope.setExtra('action', action);
        // scope.setExtra('state', store.getState());
        Sentry.captureException(err);
      });
    }
  };
};
